import React from 'react';

import {ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import {sizeLabel} from '../model/labels';
import {GlossaryDescription} from './expandable-row';
import {formatPounds} from './format';

import css from './sheet.module.css';

type Props = {
	onClose(): void;
};

export const WeightModal: React.FC<Props> = ({onClose}) => {
	const {character} = useCharacter();
	const {size, strength, multiplier, carry, pushDragLift} = character.carryingCapacity;
	const weight = character.carriedWeight;
	const sizeNote = size !== character.size ? `, размер считается как ${sizeLabel(size).toLowerCase()}` : '';
	const formula = (factor: number) => `Сила ${strength} × ${(multiplier * factor).toLocaleString('ru')}${sizeNote}`;

	return (
		<ModalPopup open onClose={onClose} header="Вес" maxWidth={560}>
			<dl className={css.weightStats}>
				<div>
					<dt className={css.groupTitle}>Переносимый вес</dt>
					<dd>
						<b>{formatPounds(carry)}</b> <span className={css.muted}>{formula(1)}</span>
					</dd>
				</div>
				<div>
					<dt className={css.groupTitle}>Толкать, тянуть или поднимать</dt>
					<dd>
						<b>{formatPounds(pushDragLift)}</b> <span className={css.muted}>{formula(2)}</span>
					</dd>
				</div>
				<div>
					<dt className={css.groupTitle}>Текущий вес</dt>
					<dd>
						<b>{formatPounds(weight)}</b>
						{weight > carry && <span className={css.attentionText}> больше переносимого веса</span>}
					</dd>
				</div>
			</dl>
			<GlossaryDescription id="carrying-capacity" className={css.restArticle} />
		</ModalPopup>
	);
};
